import {Component, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'sura-dialog-aumentar-tiempo',
  templateUrl: './dialog-aumentar-tiempo.component.html',
  styleUrls: ['./dialog-aumentar-tiempo.component.scss']
})
export class DialogAumentarTiempoComponent {

  constructor(
    public dialogRef: MatDialogRef<DialogAumentarTiempoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { tiempoAdicional }) {
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
